export const MODES = ['FTL', 'LTL', 'IMDL', 'DRAY', 'PTL', 'EXP', 'VLTL', 'OCEAN'] as const

export type Mode = (typeof MODES)[number]

export type FullMode =
  | 'less_than_truckload'
  | 'partial_truckload'
  | 'full_truck_load'
  | 'intermodal'
  | 'drayage'
  | 'EXP' //We are using the "short-name" here until we have a better source-of-truth in back-end
  | 'volume_less_than_truckload'
  | 'OCEAN'

export function isDrayageMode(mode: Mode | FullMode): boolean {
  return mode === 'drayage' || mode === 'DRAY'
}
export function isOceanMode(mode: Mode | FullMode): boolean {
  return mode === 'OCEAN'
}
export function isFullTruckLoadMode(mode: Mode | FullMode): boolean {
  return mode === 'full_truck_load' || mode === 'FTL'
}
export function isLessThanTruckloadMode(mode: Mode | FullMode): boolean {
  return mode === 'less_than_truckload' || mode === 'LTL'
}
export function isPartialTruckloadMode(mode: Mode | FullMode): boolean {
  return mode === 'partial_truckload' || mode === 'PTL'
}
export function isIntermodalMode(mode: Mode | FullMode): boolean {
  return mode === 'intermodal' || mode === 'IMDL'
}
export function isExpMode(mode: Mode | FullMode): boolean {
  return mode === 'EXP'
}
export function isVolumeLessThanTruckloadMode(mode: Mode | FullMode): boolean {
  return mode === 'volume_less_than_truckload' || mode === 'VLTL'
}
